import { useContext } from "react";
import { useValidGivenName, useValidFamilyName } from "../hooks/useAuthHooks";
import GivenName from "../components/auth/givenName";
import FamilyName from "../components/auth/familyName";
import { AuthContext } from "../context/authContext";
import { useLoading } from "../libs/loadingContext";
import { useTranslation } from "react-i18next";

export default function ChangeProfile() {
  const { givenName, setGivenName, givenNameIsValid } = useValidGivenName("");
  const { familyName, setFamilyName, familyNameIsValid } =
    useValidFamilyName("");
  const authContext = useContext(AuthContext);
  const { setLoading } = useLoading();
  const { t } = useTranslation();

  const changeProfile = async () => {
    try {
      setLoading(true);
      await authContext.setProfileAttribute(givenName, familyName);
      await authContext.refreshSession();
      localStorage.setItem(
        "profileUpdateSuccessMessage",
        t("changeProfile.transactionSuccessful")
      );
      window.location.href = "/";
    } catch (err) {
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="content-page">
        <h3 className="process-title">{t("changeProfile.processTitle")}</h3>
        <div className="profile-update-form">
          <GivenName
            givenNameIsValid={givenNameIsValid}
            setGivenName={setGivenName}
            label={t("changeProfile.newName")}
            required={false}
          />
          <FamilyName
            familyNameIsValid={familyNameIsValid}
            setFamilyName={setFamilyName}
            label={t("changeProfile.newSurname")}
            required={false}
          />
        </div>
        <div className="change-save">
          <button className="btn btn-default" onClick={() => changeProfile()}>
            {t("changeProfile.saveChanges")}
          </button>
        </div>
      </div>
    </>
  );
}
